/**
 * Sidebar Navigation
 */

// Toggle nested menu items
$('.side-nav .caret').on('click', event => {
  event.preventDefault();
  $(event.currentTarget)
    .parent('a')
    .siblings('.children')
    .slideToggle('show');
});



// WEBPACK FOOTER //
// ./assets/js/site/side-nav.js